import PracovnyKrokEnum from '../model/pracovnyKrok/PracovnyKrokEnum';
import PracovnyKrokListRequest from '../model/pracovnyKrok/PracovnyKrokListRequest';
import PracovnyKrokRequest from '../model/pracovnyKrok/PracovnyKrokRequest';

// eslint-disable-next-line max-len
const pracovnyKrokAvailable = (pracovneKroky: PracovnyKrokListRequest, pracovnyKrok: PracovnyKrokEnum): PracovnyKrokRequest => pracovneKroky?.pracovneKroky?.find(pk => pracovnyKrok === pk.pracovnyKrok);

export default pracovnyKrokAvailable;
